var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "550",
      "content-class": "rounded-lg"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on,
          isValid: _vm.isValid
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-sheet', {
    staticClass: "full-height"
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "fill-height": ""
    }
  }, [_c('bottom-sheet-header', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._v(" 이용약관 "), _c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "fab": "",
      "tile": "",
      "absolute": "",
      "right": "",
      "color": "white"
    },
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-sheet', {
    staticClass: "scroll-primary py-40 px-60",
    staticStyle: {
      "flex": "1 1 auto",
      "overflow-y": "auto"
    }
  }, [_c('v-layout', {
    staticClass: "mb-12"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "전체 동의",
      "readonly": "",
      "hide-details": ""
    },
    on: {
      "click": _vm.toggleSelectedAll
    },
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  })], 1), _c('v-divider'), _vm._l(_vm.termsList, function (term) {
    return _c('v-sheet', {
      key: term._id,
      staticClass: "mt-12"
    }, [_c('v-row', {
      staticClass: "row--small"
    }, [_c('v-col', [_c('h4', {
      staticClass: "page-text--lg"
    }, [_vm._v(_vm._s(term.subject))])]), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-checkbox', {
      attrs: {
        "value": term._id,
        "label": "약관동의",
        "hide-details": ""
      },
      model: {
        value: _vm.selected,
        callback: function callback($$v) {
          _vm.selected = $$v;
        },
        expression: "selected"
      }
    })], 1)], 1), _c('v-card', {
      staticClass: "scroll-primary mt-8",
      staticStyle: {
        "height": "20vh",
        "overflow-y": "auto"
      },
      attrs: {
        "rounded": "",
        "outlined": ""
      }
    }, [_c('div', {
      staticClass: "pa-12"
    }, [_c('p', {
      staticClass: "page-text--sm grey--text",
      domProps: {
        "innerHTML": _vm._s(term.content)
      }
    })])])], 1);
  }), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("취소하기")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.agree
    }
  }, [_c('span', [_vm._v("동의하기")])])], 1)], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }